import * as React from "react";
import "./search-form.scss";
import {cs} from "../../../../../../../../react/chain-services";
import {UseState} from "../../../../../../../../react/use-state";
import {PostalCode} from "./postal-code/postal-code";
import {AddressDistance} from "./address-distance/address-distance";
import {AddressQuantity} from "./address-quantity/address-quantity";

export const SearchForm = ({next, query}) => cs(
    ["currentType", (_, next) => UseState({
        initValue: query.value?.searchType,
        next,
    })],
    ({currentType}) => next({
        currentType,
        invalid: !currentType.value,

        render: currentType.value && (
            types[currentType.value]
        ),
    }),
);

const types = {
    "address_distance": AddressDistance,
    "address_quantity": AddressQuantity,
    "postal_code": PostalCode,
};